import React from 'react';

const DocsPage = () => {
    return <div></div>;
};

export default DocsPage;
